import { Spinner, SpinnerProps } from '@chakra-ui/react';
import type { FC } from 'react';
import { DataProps } from '../../utils';

export type QSpinnerProps = SpinnerProps & DataProps;

export const QSpinner: FC<QSpinnerProps> = (props) => {
  return <Spinner {...props} speed="0.75s" />;
};
